import ContactPageContent from '../components/ContactPageContent';

export default function ContactPage() {
  return (
    <main className="contact-page">
      <ContactPageContent showBackLink />
    </main>
  );
}
